<slotcom-legal-layout [modalName]="NonPersistedModalName.PrivacyComponent">
  <div class="e-title">{{ 'legal.privacy.title' | translate | uppercase }}</div>
  <p [innerHTML]="'legal.privacy.p-1' | translate"></p>
  <p [innerHTML]="'legal.privacy.p-2' | translate"></p>
  <p [innerHTML]="'legal.privacy.p-3' | translate"></p>

  <!-- 1. ¿Quién es el responsable de tus datos personales? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.personal-data-responsable.title' | translate"></div>
  <ul>
    <li [innerHTML]="'legal.privacy.personal-data-responsable.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.privacy.personal-data-responsable.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.privacy.personal-data-responsable.list.l-3' | translate"></li>
  </ul>
  <p [innerHTML]="'legal.privacy.personal-data-responsable.p-1' | translate"></p>

  <!-- 2. ¿Qué es un dato y un tratamiento de carácter personal? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.what-is-personal-data.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.what-is-personal-data.p-1' | translate"></p>
  <p [innerHTML]="'legal.privacy.what-is-personal-data.p-2' | translate"></p>

  <!-- 3. ¿Qué datos de carácter personal recopilamos? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.what-we-collect.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.what-we-collect.p-1' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.privacy.what-we-collect.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-collect.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-collect.list.l-3' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-collect.list.l-4' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-collect.list.l-5' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-collect.list.l-6' | translate"></li>
  </ul>
  <p [innerHTML]="'legal.privacy.what-we-collect.p-2' | translate"></p>
  <p [innerHTML]="'legal.privacy.what-we-collect.p-3' | translate"></p>
  <p [innerHTML]="'legal.privacy.what-we-collect.p-4' | translate"></p>

  <!-- 4. ¿Qué tratamientos realizamos con tus datos personales y para qué finalidades? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.what-we-perform.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.what-we-perform.p-1' | translate"></p>
  <p [innerHTML]="'legal.privacy.what-we-perform.p-2' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.privacy.what-we-perform.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-perform.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-perform.list.l-3' | translate"></li>
  </ul>
  <p [innerHTML]="'legal.privacy.what-we-perform.p-3' | translate"></p>

  <!-- 4.1 Gestión de la cuenta de los usuarios -->
  <div
    class="e-category"
    [innerHTML]="'legal.privacy.what-we-perform.user-account-management.title' | translate"></div>
  <ul>
    <li [innerHTML]="'legal.privacy.what-we-perform.user-account-management.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-perform.user-account-management.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-perform.user-account-management.list.l-3' | translate"></li>
  </ul>

  <!-- 4.2 Gestionar las peticiones de información o consultas que nos remitas -->
  <div
    class="e-category"
    [innerHTML]="'legal.privacy.what-we-perform.request-management.title' | translate"></div>
  <ul>
    <li [innerHTML]="'legal.privacy.what-we-perform.request-management.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.privacy.what-we-perform.request-management.list.l-2' | translate"></li>
  </ul>

  <!-- 4.3 Gestionar y facilitar la compra de monedas o bienes virtuales -->
  <div
    class="e-category"
    [innerHTML]="'legal.privacy.what-we-perform.purchases-management.title' | translate"></div>
  <ul>
    <li [innerHTML]="'legal.privacy.what-we-perform.purchases-management.list.l-1' | translate"></li>
  </ul>

  <!-- 4.4 Gestión de las acciones promocionales y ofertas -->
  <div
    class="e-category"
    [innerHTML]="'legal.privacy.what-we-perform.offers-management.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.what-we-perform.offers-management.p-1' | translate"></p>

  <!-- 4.5 Análisis, segmentación y perfilado del usuario para el envío de comunicaciones promocionales -->
  <div
    class="e-category"
    [innerHTML]="'legal.privacy.what-we-perform.promotional-management.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.what-we-perform.promotional-management.p-1' | translate"></p>
  <p [innerHTML]="'legal.privacy.what-we-perform.promotional-management.p-2' | translate"></p>
  <p [innerHTML]="'legal.privacy.what-we-perform.promotional-management.p-3' | translate"></p>

  <!-- 4.6 Realización de estudios estadísticos -->
  <div
    class="e-category"
    [innerHTML]="'legal.privacy.what-we-perform.statistical-studies.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.what-we-perform.statistical-studies.p-1' | translate"></p>
  <p [innerHTML]="'legal.privacy.what-we-perform.statistical-studies.p-2' | translate"></p>

  <!-- 5. ¿Durante cuánto tiempo conservamos tus datos personales? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.data-saving.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.data-saving.p-1' | translate"></p>

  <!-- 6 ¿Cómo puedo solicitar la eliminación de mis datos de usuario? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.account-deletion.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.account-deletion.p-1' | translate"></p>
  <p [innerHTML]="'legal.privacy.account-deletion.p-2' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.privacy.account-deletion.delete-account-steps.step-1' | translate"></li>
    <li [innerHTML]="'legal.privacy.account-deletion.delete-account-steps.step-2' | translate"></li>
    <li [innerHTML]="'legal.privacy.account-deletion.delete-account-steps.step-3' | translate"></li>
    <li [innerHTML]="'legal.privacy.account-deletion.delete-account-steps.step-4' | translate"></li>
    <li [innerHTML]="'legal.privacy.account-deletion.delete-account-steps.step-5' | translate"></li>
  </ul>
  <p [innerHTML]="'legal.privacy.account-deletion.p-3' | translate"></p>
  <p [innerHTML]="'legal.privacy.account-deletion.p-4' | translate"></p>

  <!-- 7. ¿Cuáles son tus derechos cuando nos facilitas tus datos personales? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.your-rights.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.your-rights.p-1' | translate"></p>

  <table>
    <tr>
      <th [innerHTML]="'legal.privacy.your-rights.table.tr-1.th-1' | translate"></th>
      <th [innerHTML]="'legal.privacy.your-rights.table.tr-1.th-2' | translate"></th>
    </tr>
    <tr>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-2.td-1' | translate"></td>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-2.td-2' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-3.td-1' | translate"></td>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-3.td-2' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-4.td-1' | translate"></td>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-4.td-2' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-5.td-1' | translate"></td>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-5.td-2' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-6.td-1' | translate"></td>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-6.td-2' | translate"></td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-7.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.privacy.your-rights.table.tr-7.td-2.p-1' | translate"></p>
        <ul>
          <li [innerHTML]="'legal.privacy.your-rights.table.tr-7.td-2.list.l-1' | translate"></li>
          <li [innerHTML]="'legal.privacy.your-rights.table.tr-7.td-2.list.l-2' | translate"></li>
        </ul>
        <p [innerHTML]="'legal.privacy.your-rights.table.tr-7.td-2.p-2' | translate"></p>
        <ul>
          <li [innerHTML]="'legal.privacy.your-rights.table.tr-7.td-2.list-2.l-1' | translate"></li>
          <li [innerHTML]="'legal.privacy.your-rights.table.tr-7.td-2.list-2.l-2' | translate"></li>
        </ul>
      </td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.privacy.your-rights.table.tr-8.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.privacy.your-rights.table.tr-8.td-2.p-1' | translate"></p>
        <p [innerHTML]="'legal.privacy.your-rights.table.tr-8.td-2.p-2' | translate"></p>
        <span [innerHTML]="'legal.privacy.your-rights.table.tr-8.td-2.p-3' | translate"></span>
        <span [innerHTML]="'legal.privacy.your-rights.table.tr-8.td-2.p-4' | translate"></span>
        <span [innerHTML]="'legal.privacy.your-rights.table.tr-8.td-2.p-5' | translate"></span>
      </td>
    </tr>
  </table>

  <!-- 8. ¿A quién comunicamos sus datos personales? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.sharing-personal-data.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.sharing-personal-data.p-1' | translate"></p>
  <p [innerHTML]="'legal.privacy.sharing-personal-data.p-2' | translate"></p>
  <p [innerHTML]="'legal.privacy.sharing-personal-data.p-3' | translate"></p>

  <!-- 9. Cambios en la presente política de privacidad -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.changes-privacy-policy.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.changes-privacy-policy.p-1' | translate"></p>

  <!-- 10. Contacto DPO -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.privacy.dpo.title' | translate"></div>
  <p [innerHTML]="'legal.privacy.dpo.p-1' | translate"></p>

  <!-- Última version -->
  <p
    class="e-lastVersion"
    [innerHTML]="'legal.privacy.last-version.p-1' | translate"></p>
</slotcom-legal-layout>
